export const courses = [
    {
        id: 1,
        courseTitle: "Flutter Development",
        courseImage: "../assets/images/flutter_training.jpeg",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                lessonVideoId: "VPvVD8t02U8",
                isCompleted: true,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 2,
        courseTitle: "iOS Development",
        courseImage: "../assets/images/ios_training.png",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 3,
        courseTitle: "React-Native Development",
        courseImage: "../assets/images/react_native_course.jpeg",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 4,
        courseTitle: "e-Commerce Mobile App design using Figma",
        courseImage: "../assets/images/figma_course.jpg",
        category: "Design",
        subCategory: "User Experience Design",
        subCategoryBranch: "Mobile App Design",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "Jack Harper",
        instructorImage: "",
        coursePrice: 20,
        originalPrice: 30,
        averageRating: 4.8,
        numberOfReviews: 997,
    },
    {
        id: 5,
        courseTitle: "e-Commerce Mobile App design using Sketch",
        courseImage: "../assets/images/sketch_course.png",
        category: "Design",
        subCategory: "User Experience Design",
        subCategoryBranch: "Mobile App Design",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "Olivia Jansen",
        instructorImage: "",
        coursePrice: 25,
        originalPrice: 30,
        averageRating: 4.6,
        numberOfReviews: 797,
    },
    {
        id: 6,
        courseTitle: "e-Commerce Mobile App design using Adobe XD",
        courseImage: "../assets/images/adobe_xd_course.jpg",
        category: "Design",
        subCategory: "User Experience Design",
        subCategoryBranch: "Mobile App Design",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "Jacob Sianturi",
        instructorImage: "",
        coursePrice: 22,
        originalPrice: 30,
        averageRating: 4.7,
        numberOfReviews: 687,
    },
    {
        id: 7,
        courseTitle: "Xamarin Development",
        courseImage: "../assets/images/xamarin_training_course.jpg",
        category: "Software Development",
        subCategory: "Mobile App Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 8,
        courseTitle: "ExpressJs Development",
        courseImage: "../assets/images/expressjs_training.jpg",
        category: "Software Development",
        subCategory: "Backend Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 9,
        courseTitle: "Django Development",
        courseImage: "../assets/images/django_training.jpg",
        category: "Sofware Development",
        subCategory: "Backend Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 10,
        courseTitle: "C++ Development",
        courseImage: "../assets/images/cpp_training.png",
        category: "Software Development",
        subCategory: "System Programming",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 11,
        courseTitle: "Angular Development",
        courseImage: "../assets/images/angular_training.jpg",
        category: "Software Development",
        subCategory: "Web Development",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
    {
        id: 12,
        courseTitle: "Java Testing",
        courseImage: "../assets/images/java_testing_training.webp",
        category: "Software Development",
        subCategory: "Code Testing",
        subCategoryBranch: "",
        currentLesson: "",
        lessons: [
            {
                lessonId: 1,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 2,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
            {
                lessonId: 3,
                lessonTitle: "",
                lessonDuration: "",
                isCompleted: false,
                completionDate: ""
            },
        ],
        instructor: "",
        instructorImage: "",
        coursePrice: 0,
        originalPrice: 0,
        averageRating: 4,
        numberOfReviews: 500,
    },
]